import { type SupplierListItem } from '@choco-admin/types';
import React from 'react';

import { FeatureFlagControlTable } from '../../../../../../components/FeatureFlagControl';

export const ORDER_AGENT_FLAG_TAG = 'oa';

/** Order Agent flags tagged for distributors. */
const ORDER_AGENT_FLAG_TAGS = [ORDER_AGENT_FLAG_TAG, 'supplier'];

interface OrderAgentFeatureFlagsProps {
  supplier: SupplierListItem;
}

export const OrderAgentFeatureFlags: React.FC<OrderAgentFeatureFlagsProps> = ({
  supplier,
}) => (
  <div className="space-y-3">
    <div>
      <h3 className="text-lg font-semibold mb-1">Feature Flags</h3>
      <p className="text-sm text-default-500">
        Order Agent features this distributor has.
      </p>
    </div>
    <FeatureFlagControlTable
      entity={{ kind: 'supplier', id: supplier.id }}
      entityName={supplier.name ?? undefined}
      tags={ORDER_AGENT_FLAG_TAGS}
    />
  </div>
);
